import axios from 'axios';

// Database configuration from development document
// const DB_CONFIG = {
//   host: 'localhost',
//   user: 'wktech',
//   password: process.env.DB_PASSWORD,
//   database: 'inventory_system',
//   port: 3308,
// }; // 暂时注释掉未使用的配置

// 修改为固定的后端地址，不再使用当前站点 origin
// const baseApiUrl = window.location.origin;
// const baseApiUrl = 'http://localhost:5003'; // 后端服务器地址
// console.log('API base URL:', baseApiUrl);

// Create axios instance with default config
const api = axios.create({
  baseURL: '/api', // 使用相对路径
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // 使用localStorage中的令牌，或者使用默认的开发令牌
    const token = (typeof localStorage !== 'undefined' && localStorage.getItem('token')) || 'dev-token-12345';
    config.headers.Authorization = `Bearer ${token}`;
    // 只在开发环境显示详细日志
    if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEBUG_API === 'true') {
      
      
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 防止 401 重复触发登出（避免并发请求多次跳转）
let _isHandling401 = false;

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const code = error.response.data?.code;

      // 收到 401：token 失效或 session 冲突，自动登出并跳转登录页
      if (status === 401 && !_isHandling401) {
        _isHandling401 = true;
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
        // 跳转到登录页，附带来源路径方便登录后返回
        const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
        const redirectTo = currentPath && currentPath !== '/login'
          ? `/login?redirect=${encodeURIComponent(currentPath)}`
          : '/login';

        // 稍作延迟，让当前调用栈的错误正常返回后再跳转
        setTimeout(() => {
          _isHandling401 = false;
          if (typeof window !== 'undefined') {
            window.location.href = redirectTo;
          }
        }, 300);
      } else {
        console.error('API响应错误:', status, error.response.data);
      }
    } else if (error.request) {
      console.error('API请求错误:', error.request);
    } else {
      console.error('API配置错误:', error.message);
    }
    return Promise.reject(error);
  }
);

const executeQuery = async (query, params = []) => {
  try {
    // In a real application, you would use a server-side API
    // Direct database access from the frontend is not secure
    // This is a simplified example based on the requirements
    const response = await api.post('/db/query', {
      sql: query,  // Changed from 'query' to 'sql' to match server expectation
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Database query error:', error);
    throw error;
  }
};

export {
  executeQuery,
  api
};
export default api;
